import { create } from "zustand";
import { apiClient } from "@/api/client";
import { AxiosError } from "axios";
import useAuthStore from "@/store/authStore";
// 
// import { presignUpload, putToS3WithProgress, confirmUpload } from "@/api/storage";

export interface Passwords {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

interface ProfileState {
  editProfile: (profileData) => Promise<void>;
  
}

const useProfileStore = create<ProfileState>((set, get) => ({
  editProfile: async (profileData) => {
    try {
      const response = await apiClient.put(
        `/users/${profileData.id}`,
        profileData
      );
      useAuthStore.getState().setUser(response.data.user);
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage =
        axiosError.response?.data?.message || "Something went wrong";
      throw new Error(errorMessage);
    }
  },
}));

export default useProfileStore;
